var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "inview",
          rawName: "v-inview:enter",
          value: _vm.comesToViewport,
          expression: "comesToViewport",
          arg: "enter"
        },
        {
          name: "inview",
          rawName: "v-inview:leave",
          value: _vm.leavesViewport,
          expression: "leavesViewport",
          arg: "leave"
        }
      ],
      class: ["job-results--item", { "loading-blockade": _vm.loadingItem }]
    },
    [
      _vm.localItem
        ? _c(
            "a",
            {
              staticClass: "job-results--item--title",
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.onItemClick.apply(null, arguments)
                }
              }
            },
            [
              _vm._v("\n\t\t" + _vm._s(_vm.listingItem.name) + "\n\t\t"),
              _vm.externalCustomer || !_vm.seen
                ? _c(
                    "span",
                    { staticClass: "job-results--item--title-badges" },
                    [
                      _vm.externalCustomer
                        ? _c(
                            "span",
                            {
                              directives: [
                                { name: "b-tooltip", rawName: "v-b-tooltip" }
                              ],
                              attrs: { title: _vm.externalCustomerHint }
                            },
                            [_vm._v("Jobvermittler")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.seen
                        ? _c(
                            "span",
                            {
                              staticClass: "job-results--item--title-badge-new"
                            },
                            [_vm._v("Neu")]
                          )
                        : _vm._e()
                    ]
                  )
                : _vm._e()
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        [
          _vm.loadingMatching
            ? _c(
                "div",
                { staticClass: "job-results--item--loading-placeholder" },
                [_c("div", [_vm._v(" ")])]
              )
            : _vm.matching
            ? [
                _c("div", { staticClass: "matching narrow-label" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "matching--category matching--category--no-y-padding"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "matching--category-items matching--category-items-no-item-x-padding"
                        },
                        _vm._l(_vm.matchingItems, function(item) {
                          return _c("MatchingItem", {
                            key: item.id,
                            attrs: {
                              label: item.label,
                              score: item.score,
                              "max-score": item.maxScore,
                              "with-percentage": false,
                              "info-text": item.infoText,
                              clickable: "",
                              "vertical-align-center": ""
                            },
                            on: { click: _vm.onItemClick }
                          })
                        }),
                        1
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _vm.localItem
                  ? _c("div", { staticClass: "job-list-item-infos" }, [
                      _vm.localItem.disclosedData
                        ? _c(
                            "div",
                            { staticClass: "job-list-item-infos-info" },
                            [
                              _c("div", [_vm._v("Firma")]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.localItem.disclosedData.companyName
                                    ) +
                                    "\n\t\t\t\t\t\t(" +
                                    _vm._s(
                                      _vm.localItem.disclosedData.contactPerson
                                    ) +
                                    ")\n\t\t\t\t\t"
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "job-list-item-infos-info",
                          attrs: { title: _vm.placesOfWork }
                        },
                        [
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.listingItem.placesOfWork.length > 1
                                  ? "Orte"
                                  : "Ort"
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(_vm._s(_vm.maxLength(_vm.placesOfWork, 35)))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "job-list-item-infos-info",
                          attrs: { title: _vm.industrialSectors }
                        },
                        [
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.listingItem.industrialSectors.length > 1
                                  ? "Branchen"
                                  : "Branche"
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.maxLength(_vm.industrialSectors, 35))
                            )
                          ])
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.localItem
                  ? _c(
                      "div",
                      { staticClass: "job-list-item-actions" },
                      [
                        !_vm.exclusion
                          ? [
                              _vm.isPublished &&
                              !_vm.localItem.communication
                                .hasOngoingConversation
                                ? _c("Button", {
                                    staticClass: "mr-2",
                                    attrs: {
                                      text: "Anonym kontaktieren",
                                      secondary: ""
                                    },
                                    on: { click: _vm.contactNow }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isPublished && _vm.messagesCount > 0
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "action turquoise",
                                      attrs: { href: "#" },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.clickedMessages.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("Icon", { attrs: { icon: "mail" } }),
                                      _vm._v(" "),
                                      _vm.newMessagesCount > 0
                                        ? _c(
                                            "span",
                                            { staticClass: "count-bubble" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.newMessagesCount)
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isPublished && _vm.hasAppointments
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "action lime",
                                      attrs: { href: "#" },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.clickedCalendar.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("Icon", {
                                        attrs: { icon: "calendar" }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "count-bubble" },
                                        [_vm._v(_vm._s(_vm.appointmentsCount))]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.exclusion
                                ? _c("Favorite", {
                                    attrs: {
                                      "job-profile-id": _vm.listingItem.id,
                                      "job-id": _vm.job.id,
                                      "initial-favored": _vm.favored,
                                      type: "application"
                                    },
                                    on: {
                                      change: function($event) {
                                        _vm.favored = $event
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.exclusion
                                ? _c("Notice", {
                                    attrs: {
                                      "job-profile-id": _vm.listingItem.id,
                                      notice: _vm.notice,
                                      type: "application",
                                      "sub-title": _vm.listingItem.name
                                    },
                                    on: {
                                      change: function($event) {
                                        _vm.notice = $event
                                      }
                                    }
                                  })
                                : _vm._e()
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _c("Exclusion", {
                          attrs: {
                            "job-profile-item": _vm.listingItem,
                            "job-id": _vm.job.id,
                            exclusion: _vm.exclusion
                          },
                          on: { change: _vm.onExclusionChange }
                        }),
                        _vm._v(" "),
                        !_vm.exclusion
                          ? [
                              _c(
                                "a",
                                {
                                  staticClass: "action no-icon",
                                  attrs: { href: "#" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.openMatchingFan.apply(
                                        null,
                                        arguments
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\tMehr Infos\n\t\t\t\t\t\t"
                                  ),
                                  _c("Icon", { attrs: { icon: "caret-right" } })
                                ],
                                1
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  : _vm._e()
              ]
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }